<template>
  <div class="user-page section-main__warp">
    <div class="left-menu">
      <div class="left-bg">
        <div class="parent-title">
          <i class="iconfont-lunan icon-lunan-lujing131"></i>
          <span class="title-text">个人信息设置</span>
        </div>
        <div
          class="title-item child-title"
          :class="{ active: activeCode === index }"
          @click="handleNodeClick(index)"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <i class="iconfont-lunan" :class="item.icon"></i>
          <span class="title-text">{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="right-content">
      <el-scrollbar ref="scroll" style="height: 100%; width: 100%">
        <div v-if="activeCode == 0" class="content">
          <div>
            <ioc-form
              :option="userInfoOptions"
              v-model="form"
              @submit="updateUserInfo"
              @reset-change="reset"
            >
              <template v-slot:fileCode>
                <el-upload
                  action="common/file/batchFileload.json"
                  class="el-upload-single"
                  :file-list="fileList"
                  ref="addAvatar"
                  :multiple="false"
                  name="files"
                  :show-file-list="true"
                  :list-type="'picture-card'"
                  accept="image/png, image/jpg, image/jpeg, image/bpm"
                  :auto-upload="true"
                  :disabled="false"
                  :limit="1"
                  :before-upload="beforeAvatarUpload"
                  :on-success="handleSuccess"
                  :on-change="handleChangeFile"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </template>
            </ioc-form>
          </div>
        </div>
        <div v-else-if="activeCode == 1" class="content">
          <div>
            <ioc-form :option="passOption" v-model="passForm" @submit="submit"></ioc-form>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <!-- <ioc-tab-group :option="option" @change="handleChange"></ioc-tab-group> -->
  </div>
</template>
<script>
// 工具库-Cache缓存操作工具库
import sysInit from "@src/init";
import { Cache, Dates, Dic } from "$utils";
import sha256 from "js-sha256";
export default {
  data() {
    return {
      activeCode: 0,
      dataList: [
        { label: "个人信息", value: 0, icon: "icon-lunan-xitongshezhi" },
        { label: "修改密码", value: 1, icon: "icon-lunan-renwuguanli1" },
      ],
      codeType: 1,
      addUploadBtnDom: null,
      fileList: [],
      fileCode: "",
      accountNumber: "",
      type: {},
      form: {},
      passForm: {
        oldpass: "",
        pass: "",
        againPass: "",
      },
      codeTypeArray: [
        {
          label: "任意字符",
          value: 1,
        },
        {
          label: "字母+数字混和",
          value: 2,
        },
        {
          label: "大写字母+小写字母+数字混合",
          value: 3,
        },
      ],
      option: {
        column: [
          {
            label: this.$t("base.label.personalInfo"),
            prop: "user-info",
          },
          {
            label: this.$t("base.label.editPwd"),
            prop: "pass-profile",
          },
        ],
      },
      userInfoOptions: {
        submitText: this.$t("base.button.save"),
        emptyText: this.$t("base.button.reset"),
        column: [
          {
            label: this.$t("base.label.account"),
            prop: "accountNumber",
            disabled: true,
            slot: true,
            overHidden: true,
            align: "left",
            span: 24,
            maxlength: 320,
            rules: [
              {
                required: true,
                message: this.$t("base.message.account"),
                trigger: "blur",
              },
            ],
            placeholder: this.$t("base.placeholder.account"),
          },
          {
            label: this.$t("base.label.name"),
            prop: "accountName",
            editDisplay: true,
            overHidden: true,
            span: 24,
            maxlength: 320,
            rules: [
              {
                required: true,
                message: this.$t("base.message.name"),
                trigger: "blur",
              },
              {
                min: 1,
                max: 50,
                message: this.$t("base.message.less50"),
                trigger: "blur",
              },
            ],
            placeholder: this.$t("base.placeholder.name"),
          },
          {
            label: this.$t("base.label.sex"),
            prop: "sex",
            span: 24,
            type: "radio",
            // valueDefault: 1,
            rules: [
              {
                required: true,
                message: this.$t("base.message.sex"),
                trigger: "blur",
              },
            ],
            dicData: Dic.find("SENU018"),
          },
          {
            label: this.$t("base.label.avatar"),
            prop: "fileCode",
            formslot: true,
            span: 24,
            /* labelWidth: '88',
            type: 'radio',
            valueDefault: 1,
            rules: [{ required: true, message: this.$t('base.message.sex'), trigger: 'blur' }],
            dicData: Dic.find('SENU018'), */
          },
          {
            label: this.$t("base.label.phone"),
            align: "center",
            prop: "phone",
            type: "text",
            value: "",
            maxlength: 11,
            rules: [
              {
                required: true,
                message: this.$t("base.message.phone"),
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  var reg = new RegExp("^1[3456789]\\d{9}$");
                  if (!reg.test(value)) {
                    callback(new Error(this.$t("base.message.phoneCheck")));
                  } else {
                    callback();
                  }
                },
                trigger: "blur",
              },
            ],
            span: 24,
            placeholder: this.$t("base.placeholder.phone"),
          },
          {
            label: this.$t("base.label.email"),
            prop: "email",
            type: "text",
            value: "",
            maxlength: 320,
            rules: [
              {
                required: true,
                message: this.$t("base.message.email"),
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  var reg = new RegExp(
                    "^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$"
                  );
                  if (!reg.test(value)) {
                    callback(new Error(this.$t("base.message.emailCheck")));
                  } else if (value.indexOf("@") > 18 || value.indexOf("@") < 4) {
                    callback(new Error(this.$t("base.message.emailFormat")));
                  } else {
                    callback();
                  }
                },
                trigger: "blur",
              },
            ],
            span: 24,
            placeholder: this.$t("base.placeholder.email"),
          },
          {
            label: this.$t("base.label.remark"),
            prop: "desc",
            span: 24,
            type: "textarea",
            hide: true,
            minRows: 10,
            maxlength: 400,
            placeholder: this.$t("base.placeholder.remark"),
          },
        ],
      },
      passOption: {
        submitText: this.$t("base.button.save"),
        emptyText: this.$t("base.button.reset"),
        column: [
          {
            span: 24,
            label: this.$t("base.label.oldPwd"),
            type: "password",
            prop: "oldpass",
            rules: [
              {
                required: true,
                message: this.$t("base.message.oldPwd"),
                trigger: "blur",
              },
            ],
            placeholder: this.$t("base.placeholder.oldPwd"),
          },
          {
            span: 24,
            label: this.$t("base.label.newPwd"),
            type: "password",
            prop: "pass",
            rules: [
              {
                required: true,
                message: this.$t("base.message.newPwd"),
                trigger: "blur",
              },
              {
                min: 6,
                max: 6,
                message: "密码长度为6个字符",
                trigger: ["blur", "change"],
              },
              { validator: this.validatePwd, trigger: ["blur"] },
            ],
            placeholder: this.$t("base.placeholder.newPwd"),
          },
          {
            span: 24,
            label: this.$t("base.label.confirmPwd"),
            type: "password",
            prop: "againPass",
            tipPlacement: "left",
            rules: [
              {
                required: true,
                message: this.$t("base.message.confirmPwd"),
                trigger: "blur",
              },
              { validator: this.validatePass, trigger: "blur" },
            ],
            placeholder: this.$t("base.placeholder.confirmPwd"),
          },
        ],
      },
    };
  },
  created() {
    this.type = this.option.column[0];
    this.getSyConfig();
  },
  mounted() {
    this.getUserInfo();
    this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1];
    this.addUploadBtnDom.style.display = "none";
  },
  methods: {
    getSyConfig() {
      let params = {
        cfgCode: "PASSWORD_FORMAT,PASSWORD_LENGTH",
        pageNum: 1,
        pageSize: 10,
      };
      this.$fetch(this.$api.common.querySysConfig, params).then((res) => {
        if (res.success) {
          this.codeType = Number(res.returnObj.list[0].cfgValue); //3
          this.passOption.column[1].rules[1].max = Number(res.returnObj.list[1].cfgValue);
          this.passOption.column[1].rules[1].min = Number(res.returnObj.list[1].cfgValue);
          this.passOption.column[1].rules[1].message =
            "密码长度为" + Number(res.returnObj.list[1].cfgValue) + "位字符";
        }
        console.log(this.passOption);
      });
    },
    beforeAvatarUpload(file) {
      const isImg = ["image/png", "image/jpg", "image/jpeg", "image/bpm"].includes(
        file.type
      );
      if (!isImg) this.$message.error("图片类型错误,只能是png/jpg/jpeg/bpm中的一种");
      return isImg;
    },
    handleNodeClick(index) {
      this.activeCode = index;
      if (index == 0) {
        this.getUserInfo();
      }
    },
    handleChange(column) {
      this.type = column;
      if (column.prop == "user-info") {
        this.getUserInfo();
      }
    },
    handleChangeFile(file, fileList) {
      this.addUploadBtnDom.style.display = "none";
    },
    handleRemove(file, fileList) {
      this.fileCode = "";
      this.fileList = [];
      this.addUploadBtnDom.style.display = "inline-block";
    },
    handleExceed(file, fileList) {
      this.$message({
        showClose: false,
        message: this.$t("base.message.fileExceed"),
        type: "error",
        duration: 2000,
      });
    },
    handleSuccess(res, file, fileList) {
      if (res.success) {
        this.fileCode = res.returnObj[0].fileId;
      }
    },
    // 获取用户信息
    getUserInfo() {
      const userInfoCache = this.$store.getters.userInfo;
      this.form = {
        accountNumber: userInfoCache.account,
        accountName: userInfoCache.nickName,
        phone: userInfoCache.phone,
        email: userInfoCache.email,
        desc: userInfoCache.desc,
        sex: userInfoCache.sex,
      };
      this.accountNumber = userInfoCache.account;
      this.fileList = [];
      this.fileList.push({ url: userInfoCache.avatarImg });
      this.fileCode = userInfoCache.fileCode;
    },
    fileUpload() {
      const formData = new FormData();
      if (this.fileList[0].raw) {
        formData.append("files", this.fileList[0].raw);
      }
      return this.$fetch("/common/file/batchFileload.json", formData);
    },
    submit() {
      const self = this;
      let params = {
        accountNumber: this.accountNumber,
        oldPassword: sha256(this.passForm.oldpass),
        newPassword: sha256(this.passForm.pass),
        confirmPassword: sha256(this.passForm.againPass),
      };
      if (params.accountNumber === this.passForm.pass) {
        self.$message.error(this.$t("base.message.sameWithAccount"));
      } else {
        self.$fetch("cms/account/changePassword.json", params).then((res) => {
          if (!res.success) {
            self.$message.error(res.msgContent);
            return;
          } else {
            self.$message.success(this.$t("base.message.editPwdSuccess"));
            self.passForm.oldpass = "";
            self.passForm.pass = "";
            self.passForm.againPass = "";
          }
        });
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$t("base.message.againPwd")));
      } else if (value !== this.passForm.pass) {
        callback(new Error(this.$t("base.message.diffPwd")));
      } else {
        callback();
      }
    },
    validatePwd(rule, value, callback) {
      let reg = "";
      if (this.codeType == 2) {
        // 数字+任意英文
        reg = new RegExp("^((?=.*\\d)(?=.*[A-Za-z]))[0-9a-zA-Z]*$");
      } else if (this.codeType == 3) {
        //数字+英文(大写+小写)
        reg = new RegExp("^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$");
        // ^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]))[0-9a-zA-Z]*$
      } else {
        //任意密码
        callback();
        return;
      }
      if (!reg.test(value)) {
        callback(
          new Error("密码格式错误,必须包含" + this.codeTypeArray[this.codeType - 1].label)
        );
      } else {
        callback();
      }

      // var reg = new RegExp(
      //   "^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^\\s0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^\\s0-9a-zA-Z]))[^\\s]+)$"
      // );
      // if (!reg.test(value)) {
      //   callback(new Error(this.$t("base.message.passwordCheck2")));
      // } else {
      //   callback();
      // }
    },
    //重置用户信息时，应该回填账户名
    reset() {
      this.form.accountNumber = this.accountNumber;
    },
    // 修改用户信息
    async updateUserInfo() {
      if (!this.fileCode) {
        this.$message.warning("请先上传头像");
        return;
      }
      this.$fetch("/cms/account/queryRlatAcctGroup.json", {
        accountNumber: this.form.accountNumber,
      }).then((response) => {
        const list = response.returnObj.map((item) => {
          let beginTime = "",
            endTime = "";
          if (item.date && item.date.length) {
            item.date = [
              Dates.parse(Dates.format(item.date[0])),
              Dates.parse(Dates.format(item.date[1])),
            ];
            beginTime = Dates.format(_.result(item, "date[0]", Date()));
            endTime = Dates.format(_.result(item, "date[1]", Date()));
          }
          return {
            accountGroupCode: item.accountGroupCode,
            beginTime: beginTime,
            endTime: endTime,
          };
        });
        const params = {
          accountNumber: this.form.accountNumber,
          desc: this.form.desc,
          status: 1, //默认修改时启用
          nickName: this.form.accountName,
          email: this.form.email,
          sex: this.form.sex,
          accountGroupList: list,
          phone: this.form.phone,
          fileCode: this.fileCode,
        };
        this.$fetch("/cms/account/update.json", params).then(async (res) => {
          if (res.success) {
            this.$message({
              showClose: false,
              message: this.$t("base.message.editSuccess"),
              type: "success",
              duration: 2000,
            });
            await sysInit.getUserLoginInfo.apply(this);
            this.getUserInfo();
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
              duration: 2000,
            });
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.left-menu {
  margin-right: 8px;
  width: 380px;
  // padding: 15px;
  @include set_theme_color(background-color, page-bg-color);
  .left-bg {
    height: 100%;
    padding: 16px 0px;
    @include set_theme_color(background-color, left-menu-bg-color);
    // @include set_theme_color(background-color, main-content-bg-color);
  }
}
.parent-title {
  padding-left: 20px;
  margin-bottom: 10px;
}
.title-item {
  padding: 10px 20px;
}
.title-text {
  margin-left: 10px;
}
.child-title {
  padding-left: 30px;
  cursor: pointer;

  &:hover {
    @include set_theme_color(background-color, input-default-bg-color);
    @include set_theme_color(color, main-theme-color);
  }

  &.active {
    @include set_theme_color(background-color, menu-tab-bg-color);
    @include set_theme_color(color, main-theme-color);
  }
}
.right-content {
  // margin-top: 10px;
  // padding-top: 10px;
  @include set_theme_color(background-color, left-menu-bg-color);
  flex: 1;
}
.content {
  height: 100%;
  // overflow: auto;
  padding: 44px 10% 44px 54px;
  > div {
    // width: 70%;
    // margin: 0 auto;
    // max-width: 800px;
  }
}
.user-page {
  // @include set_theme_color(background-color, left-menu-bg-color);
  // display: flex;
  // flex-direction: column;
  width: 100%;
  // padding: 10px 20px;
  // background: #181f2e;
  // margin: 0 16px;
}
</style>
